<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'blue'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.back')"
        :icon="error ? 'mdi-alert' : 'mdi-page-previous'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnPrevious',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>